module.exports = __webpack_public_path__ + "img/Trainers-background-sm.4444bd96.webp";